import { MySelector } from "../../redux/store"
import SendOtp from "./SendOtp"
import VerifyOtp from "./VerifyOtp"
import logo from "../../assets/itsForeverLogo.png"
import logo_light from "../../assets/ife-logo-light.png"
import { formatEventDate } from "../../utils/formatEventDate"

const AuthModal = () => {
  const { data, otpSent } = MySelector((state) => state.event)
  const { theme } = MySelector((state) => state.theme)

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
      {/* Light scrim keeps the gallery visible behind while blocking interaction */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Auth card */}
      <div className="relative z-10 w-full max-w-md rounded-xl border border-[#EEE6D9] dark:border-golden/40 bg-white dark:bg-black shadow-2xl px-6 py-8 md:px-10 md:py-10 max-h-[90vh] overflow-y-auto font-cormorant">
        <div className="flex justify-center">
          {otpSent ? <VerifyOtp /> : <SendOtp />}
        </div>
      </div>
    </div>
  )
}

export default AuthModal
